import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface IData {
  numberPieces: number;
  isPackage: boolean;
}
@Component({
  selector: 'app-request-pieces-dialog',
  templateUrl: './request-pieces-dialog.component.html',
  styleUrls: ['./request-pieces-dialog.component.scss'],
})
export class RequestPiecesDialogComponent implements OnInit {
  initialPiece?: number;
  disabledButton = false;
  constructor(
    public dialogRef: MatDialogRef<number>,
    @Inject(MAT_DIALOG_DATA) public data: IData
  ) {}

  ngOnInit(): void {
    this.initialPiece = this.data.numberPieces;
  }

  getPieces(currentPieces: number): void {
    this.initialPiece = currentPieces;
    this.disabledButton = false;
  }
  accept(): void {
    this.dialogRef.close(this.initialPiece);
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  lockItemsEditOrder(currentPieces: number): void {
    this.initialPiece = currentPieces;
    this.disabledButton = true;
  }
}
